const theme = {
  blue: '#2642d8',
  darkBlue: '#122dbe',
  darkYellow: '#e0b120',
  darkerGrey: '#303030',
  green: '#4f987a',
  lightGreen: '#85af81',
  grey: '#eee',
  gothic: '#6B868D',
  lightGrey: '#e3e3e3',
  lighterGrey: '#f3f3f3',
  lightestGrey: '#f9f9f9',
  mediumGrey: '#999',
  darkGrey: '#5b5b5b',
  warmGrey: '#767676',
  textColor: '#3e3e3e',
  yellow: '#ebbf38',
  primaryFont: 'Circular',
  lightFontColor: '#6c6c6c',
  linkColor: '#2642DD',
  linkVisitedColor: '#551a8b',
  red: '#ff3b30'
}

export default theme
